export default {
  productType: {
    COUNT_TICKET: 'Count Ticket',
    TIME_TICKET: 'Time Pass',
  },
  user: {
    nickName: 'Name',
    account: 'Account',
    email: 'Email',
    phonenumber: 'Phone Number',
    bindEmployee: 'Bind Employee',
    bindSuccess: 'Bound successfully',
  },
  decorate: {
    notice: 'Customize each channel independently, or sync a page to other channels with one click.',
    miniProgram: 'Mini Program',
    officialAccount: 'Official Account H5',
    enterDecoration: 'Open Designer',
    application: 'Application',
    selectApplication: 'Select an application',
    refresh: 'Refresh',
    resetPage: 'Reset Page',
    resetPageConfirm: 'Reset this page? The page will return to the system default structure and unsaved changes will be overwritten. You must still save after resetting.',
    unsavedTitle: 'Unsaved Changes',
    unsavedMessage: 'Your changes will not be kept after leaving.',
    continueEditing: 'Continue Editing',
    discardChanges: 'Discard Changes',
    exportPage: 'Export Page',
    importPage: 'Import Page',
    importPageConfirm: 'Select a JSON page configuration file. After validation, it will overwrite the current page content. You can continue editing before saving.',
    exportPageConfirm: 'This will export the complete configuration of the current page without changing its content or save status.',
    pageExported: 'Page exported successfully',
    pageImported: 'Page imported successfully',
    pageImportInvalid: 'Import failed. The file format is invalid.',
    mallPages: 'Storefront Pages',
    pageListTitle: 'Pages',
    pageTotal: '{count} total',
    systemPage: 'System Page',
    addTemplate: 'New Template',
    copyTemplate: 'Copy Template',
    templateName: 'Template Name',
    templateLibrary: 'Template Library',
    templateLibraryTip: 'Templates are initialized by the brand system. Their content is read-only and can only be previewed here.',
    templateLibrarySelectTip: 'Select a template matching the current page type, then continue customizing its content.',
    chooseTemplate: 'Select Template',
    applyTemplateTitle: 'Apply Template',
    applyTemplateConfirm: 'Apply “{templateName}” to “{pageName}”? Existing content on this page will be overwritten. You can continue editing before saving.',
    templateSelected: 'Template loaded. Continue customizing and save when ready.',
    templatePageMismatch: 'The template page type does not match the current page.',
    allPages: 'All Pages',
    noTemplates: 'No templates available',
    templateLoadFailed: 'Failed to load templates. Please try again later.',
    defaultTemplate: 'Default Template',
    unnamedTemplate: 'Unnamed Template',
    enterTemplateName: 'Enter a template name',
    templateCreated: 'Blank template created',
    home: 'Home',
    mallCategory: 'Categories',
    userCenter: 'User Center',
    productDetail: 'Product Details',
    page: 'Page',
    preview: 'Preview',
    copy: 'Copy',
    skip: 'Skip',
    decorate: 'Design',
    rename: 'Rename',
    apply: 'Change App',
    delete: 'Delete',
    addPage: 'Add Page',
    renamePage: 'Rename Page',
    enterPageName: 'Enter a page name',
    claimNow: 'Claim Now',
    channelComingSoon: 'Pages for this channel are being prepared.',
    demoApplication: 'Demo Application',
    mallApplication: 'Store Application',
    enteredDecoration: 'Designer opened',
    refreshed: 'Page refreshed',
    enabled: 'Page enabled',
    disabled: 'Page disabled',
    templateActive: 'Active',
    templateInactive: 'Inactive',
    switchTemplateConfirmTitle: 'Switch Active Template',
    switchTemplateConfirmMessage: 'Switching will deactivate the currently active template. Set this template as active?',
    deactivateTemplateConfirmTitle: 'Deactivate Page Template',
    deactivateTemplateConfirmMessage: 'After deactivation, this custom page may temporarily have no active template. The template content will be retained. Deactivate it?',
    templateActivated: 'Template activated',
    templateDeactivated: 'Template deactivated',
    systemPageActiveRequired: 'A system page must retain one active template',
    applied: 'Application changed',
    renamed: 'Page renamed',
    deleteTemplateConfirm: 'Delete template “{name}”?',
    templateDeleted: 'Template deleted',
    templateCopied: 'Template copied',
    deleted: 'Page deleted',
    newPage: 'New Page',
    startDecoration: 'Start Designing',
    templateRegular: 'Template — Standard',
    templateNewYear: 'Template — New Year',
    templateValentine: 'Template — Valentine',
    templateDark: 'Template — Minimal Dark',
    templateMarket: 'Template — Fresh Market',
    templateFood: 'Template — Food',
    templateTea: 'Template — Tea',
    templateMall: 'Store Page',
    heroCarnival: 'Carnival Season',
    heroCoupon: 'Big Coupons Are Here',
    heroCongratulations: 'Coupon Unlocked',
    heroFifty: '$50',
    heroValentine: 'A Special Valentine Offer',
    heroDiscount: 'Save 10% More',
    heroShorts: 'RC SHORT Collection',
    heroFreedom: 'Move Freely',
    heroFreshMarket: 'Fresh Market',
    heroTodayDeal: "Today's Deals",
    heroFood: 'Comfort Food',
    heroTryNew: 'Try Something New',
    heroSummerTea: 'Summer Tea',
    heroNewTea: 'Freshly Launched',
    heroMember: 'Members Only',
    heroMallGoods: 'Store Picks',
    clearSelection: 'Clear Selection',
    previewPage: 'Preview Page',
    noPreviewContent: 'No preview content available',
    copyPage: 'Copy Page',
    sharePage: 'Share Page',
    moveUp: 'Move Up',
    moveDown: 'Move Down',
    copyComponent: 'Copy Component',
    actionCompleted: 'Action completed',
    memberInfoComponent: 'Member Info',
    memberCodeComponent: 'Member Code',
    assetOverviewComponent: 'Asset Overview',
    memberPreviewName: 'Member Name',
    memberPreviewPhone: '159****0000',
    memberPreviewNo: 'User ID U10086001',
    memberPreviewLevel: 'Diamond Member',
    showMemberAvatar: 'Show Avatar',
    showMemberNickname: 'Show Nickname',
    showMemberLevel: 'Show Member Level',
    showMemberPhone: 'Show Phone Number',
    showMemberNo: 'Show User ID',
    colorSettings: 'Color Settings',
    primaryTextColor: 'Primary Text Color',
    secondaryTextColor: 'Secondary Text Color',
    memberLevelBackgroundColor: 'Level Background',
    memberLevelTextColor: 'Level Text Color',
    memberCodeRefreshHint: 'Refreshes member code in {seconds} seconds',
    memberCodeSettings: 'Member Code Settings',
    memberCodeAreaHeight: 'Code Area Height',
    memberCodeSize: 'QR Code Size',
    codeHorizontalPosition: 'QR Code Horizontal Position',
    codeVerticalPosition: 'QR Code Vertical Position',
    codePositionHint: 'The height of the QR code and border image cannot exceed the code area height',
    borderImage: 'Border Image',
    borderImageWidth: 'Border Width',
    borderImageHeight: 'Border Height',
    horizontalPosition: 'Horizontal Position',
    verticalPosition: 'Vertical Position',
    borderImagePositionHint: 'Positive horizontal moves right, positive vertical moves down, negative values reverse',
    showRefreshCountdown: 'Show Refresh Countdown',
    refreshIntervalSeconds: 'Refresh Interval (seconds)',
    codeColor: 'QR Code Color',
    accentColor: 'Accent Color',
    hintColor: 'Hint Text Color',
    assetDisplay: 'Assets to Display',
    assetYearMonthPass: 'Year/Month Pass',
    assetCountPass: 'Count Pass',
    assetEmpty: 'Select assets to display',
    assetAmountColor: 'Asset Amount Color',
    assetLabelColor: 'Asset Label Color',
    orderCenterComponent: 'Order Center',
    myOrders: 'My Orders',
    allOrders: 'All Orders',
    pendingPayment: 'To Pay',
    pendingArrival: 'To Arrive',
    pendingReceipt: 'To Receive',
    completedOrders: 'Completed',
    afterSalesRefund: 'After-sales',
    orderCenterBackgroundSettings: 'Order Center Background',
    orderCenterBackgroundSizeHint: 'Recommended: 750px × 252px or the same aspect ratio',
    myServiceComponent: 'My Services',
    myServiceTitle: 'My Services',
    myServiceMore: 'More',
    personalProfile: 'Profile',
    myAssets: 'My Assets',
    coupon: 'Coupons',
    customerService: 'Customer Service',
    storeInfo: 'Store Information',
    myServiceEmpty: 'No service shortcuts to display',
    myServiceBackgroundSettings: 'My Services Background',
    myServiceBackgroundSizeHint: 'Recommended: 750px × 308px or the same aspect ratio',
    searchComponent: 'Search',
    searchBox: 'Search Box',
    searchBoxBackgroundColor: 'Search Box Background',
    borderBackgroundColor: 'Border Background',
    searchText: 'Search Text',
    placeholderText: 'Placeholder',
    searchIconColor: 'Search Icon Color',
    searchButtonTextColor: 'Search Text Color',
    searchButton: 'Search',
    searchPlaceholder: 'Enter keywords',
    searchIconImage: 'Search Icon Image',
    showImage: 'Show Image',
    searchIconSizeHint: 'Recommended: 30px × 30px or the same aspect ratio',
    searchBorderRadius: 'Search Border Radius',
    rightImage: 'Right Image',
    rightImageSizeHint: 'Recommended size: 40px × 40px',
    imageWidth: 'Image Width',
    imageHeight: 'Image Height',
    borderColor: 'Border Color',
    categoryComponent: 'Categories',
    mallCategoryComponent: 'Mall Categories',
    mobilePhone: 'Phones',
    computer: 'Computers',
    tablet: 'Tablets',
    television: 'TVs',
    wearable: 'Wearables',
    headphones: 'Headphones',
    shoppingCartDisplay: 'Cart Display',
    defaultProductName: 'Featured Quality Product',
    selectedItems: '{count} selected',
    totalAmount: 'Total:',
    checkout: 'Checkout',
    buy: 'Buy',
    firstTitle: 'First Title',
    pageJumpConfig: 'Page Navigation',
    layoutSettings: 'Layout Settings',
    offset: 'Offset',
    gridSpan: 'Grid Span',
    navigationComponent: 'Icon Navigation',
    carouselComponent: 'Carousel',
    productCarouselComponent: 'Product Carousel',
    productCarouselHint: 'Product detail images are loaded automatically. If the product has a video, it is shown as the first slide.',
    noticeComponent: 'Notice',
    componentLibrary: 'Component Library',
    componentManager: 'Component Manager',
    componentSettings: 'Component Settings',
    componentLimit: 'Add up to 99 components',
    itemsPerRow: 'Items per Row',
    recommendedSize: 'Recommended Size',
    navigationSizeHint: '120px × 120px or the same aspect ratio',
    navigationImage: 'Image',
    navigationName: 'Name',
    navigationPage: 'Page',
    navigationLinkPlaceholder: 'Enter a page path or custom link',
    navigationNamePlaceholder: 'Enter a navigation name',
    defaultNavigationName: 'Title Text',
    addNavigationButton: 'Add Navigation Button',
    navigationLimitHint: 'Add up to 10 navigation buttons',
    carouselImages: 'Carousel Images',
    addCarouselImage: 'Add Carousel Image',
    carouselEmpty: 'No carousel images',
    carouselLimitHint: 'Select up to 5 images',
    carouselRecommendedSize: 'Recommended size: 750px × {height}px',
    selectPage: 'Select a page',
    autoplay: 'Autoplay',
    switchInterval: 'Interval',
    intervalMilliseconds: 'Interval (milliseconds)',
    noticeList: 'Notices',
    noticeBadge: 'News',
    noticeEmpty: 'No notices',
    noticeLimitHint: 'Add up to 5 notices, with 25 characters each',
    addNotice: 'Add Notice',
    noticeTextPlaceholder: 'Enter notice text',
    pageType: 'Page Type',
    pageTypePlaceholder: 'Enter a page type',
    pageCode: 'Page Code',
    pageCodePlaceholder: 'Enter a page code',
    noticeImageSizeHint: 'Use a clear, compact image',
    defaultNotice: 'Welcome! Offers are live.',
    hotSaleComponent: 'Hot Sale',
    seckillComponent: 'Flash Sale',
    tabBarComponent: 'Tab Bar',
    componentContent: 'Component Content',
    basicStyle: 'Basic Style',
    styleOptimization: 'Style Optimization',
    componentName: 'Component Name',
    staticComponentContentHint: 'This component has no editable content. Use the other tabs to adjust its appearance.',
    backgroundSettings: 'Component Basic Style',
    backgroundColor: 'Background',
    optimizedBackgroundColor: 'Override Background',
    padding: 'Component Padding',
    margin: 'Component Margin',
    borderRadius: 'Border Radius',
    top: 'Top',
    bottom: 'Bottom',
    left: 'Left',
    right: 'Right',
    topLeft: 'Top Left',
    topRight: 'Top Right',
    bottomLeft: 'Bottom Left',
    bottomRight: 'Bottom Right',
    displaySettings: 'Display Settings',
    showText: 'Show Text',
    textColor: 'Text Color',
    backgroundImage: 'Background Image',
    imageUrl: 'Image URL',
    enterImageUrl: 'Enter a background image URL',
    videoComponent: 'Video',
    videoEmpty: 'Configure a video URL',
    videoUrl: 'Video URL',
    enterVideoUrl: 'Enter a video URL',
    videoPosterUrl: 'Video Poster URL',
    enterVideoPosterUrl: 'Enter a video poster URL',
    videoControls: 'Show Controls',
    videoAutoplay: 'Autoplay',
    videoLoop: 'Loop Playback',
    videoMuted: 'Muted Playback',
    multiImageComponent: 'Multiple Images',
    multiImageStyle: 'Layout Style',
    styleOne: 'Style One',
    styleTwo: 'Style Two',
    styleThree: 'Style Three',
    displayHeight: 'Display Height',
    imageGap: 'Image Gap',
    multiImageList: 'Images',
    multiImageEmpty: 'No images',
    multiImageFixedSlotsHint: 'This style uses {count} fixed image slots',
    dragToSort: 'Drag to sort',
    multiImageRecommendedSize: 'Recommended size: {size}',
    selectImage: 'Select an image',
    singleImageComponent: 'Single Image',
    singleImageEmpty: 'Select one image',
    singleImageRecommendedSize: 'Recommended size: {size} or the same aspect ratio',
    imageHotspotComponent: 'Image Hotspots',
    imageHotspotEmpty: 'Select a base image first',
    editHotspots: 'Edit Hotspots',
    hotspotList: 'Hotspot List',
    addHotspot: 'Add Hotspot',
    hotspotEmpty: 'No hotspots yet',
    hotspotHint: 'Drag a hotspot to move it, or drag its bottom-right handle to resize it',
    hotspotArea: 'Hotspot {index}',
    hotspotImage: 'Base Image',
    deleteHotspot: 'Delete Hotspot',
    titleTextComponent: 'Title Text',
    defaultTitleText: 'Title Text',
    titleTextPlaceholder: 'Enter text content',
    imageHeightPlaceholder: 'Image height',
    textMarginPlaceholder: 'Text margin',
    fontWeightPlaceholder: 'Bold text, enter 100-900',
    jumpLink: 'Destination',
    background: 'Background',
    textStyle: 'Text Style',
    titleText: 'Title Text',
    textAlignment: 'Text Alignment',
    alignLeft: 'Align Left',
    alignCenter: 'Align Center',
    alignRight: 'Align Right',
    leftMargin: 'Left Margin',
    rightMargin: 'Right Margin',
    verticalMargin: 'Vertical Margin',
    fontSize: 'Font Size',
    fontWeight: 'Font Weight',
    lineHeight: 'Text Line/Component Height',
    backgroundImageRecommendedSize: 'Recommended: 750px × {height}px or the same aspect ratio',
    enableBorderRadius: 'Enable Border Radius',
    productRecommendationComponent: 'Product Recommendations',
    productInfoComponent: 'Product Information',
    productDetailTitleComponent: 'Product Detail Title',
    productSpecificationComponent: 'Specification Selector',
    productPurchaseComponent: 'Purchase Actions',
    productInfoContent: 'Product Information · Content',
    showProductDescription: 'Show Product Description',
    productTitleColor: 'Product Title Color',
    specification: 'Specification',
    selectSpecificationHint: 'Select a product specification',
    quantity: 'Quantity',
    showPurchaseQuantity: 'Show Purchase Quantity',
    labelColor: 'Label Color',
    contentColor: 'Content Color',
    showCustomerService: 'Show Customer Service',
    showShoppingCart: 'Show Shopping Cart',
    showAddToCart: 'Show Add to Cart',
    addToCart: 'Add to Cart',
    buyNow: 'Buy Now',
    buyNowBackground: 'Buy Now Background',
    buyNowTextColor: 'Buy Now Text Color',
    addToCartBackground: 'Add to Cart Background',
    addToCartTextColor: 'Add to Cart Text Color',
    applicableScope: 'Applicable Scope',
    allProducts: 'Applies to All Products',
    productInfoScopeDescription: 'This template applies to every product detail page. The storefront loads the product selected by the customer instead of binding one here.',
    displayContent: 'Display Content',
    showOriginalPrice: 'Show List Price',
    showSoldQuantity: 'Show Sold Quantity',
    showStock: 'Show Stock',
    systemProductData: 'System Product Data',
    productInfoDataSourceDescription: 'Product name, sale price, list price, sold quantity, and stock are loaded from current product data and cannot be edited here.',
    productPreviewName: 'All-Day Single Admission Ticket',
    productPreviewDescription: 'Unlimited same-day access to activities, ideal for family visits',
    stockCount: '{count} in stock',
    defaultRecommendationTitle: 'Featured Picks',
    dataSource: 'Data Source',
    defaultLoad: 'Default',
    specifiedCategory: 'Specific Categories',
    specifiedBrand: 'Specific Brand',
    specifiedProducts: 'Specific Products',
    selectProducts: 'Select Products',
    productImage: 'Product Image',
    productName: 'Product Name',
    productCode: 'Product Code',
    mnemonicCode: 'Mnemonic Code',
    productType: 'Product Type',
    productSubType: 'Product Subtype',
    backendCategory: 'Backend Category',
    frontendCategory: 'Storefront Category',
    storefrontCategory: 'Storefront Category',
    countTicket: 'Count Ticket',
    timeTicket: 'Year/Month Pass',
    selectCategory: 'Select storefront categories',
    selectBrand: 'Select Brand',
    selectedBrandId: 'Selected brand ID: {id}',
    selectedProductCount: '{count} products selected',
    productQuantity: 'Product Quantity',
    productSort: 'Product Sort',
    sortDescending: 'Sort Descending',
    lowestPriceFirst: 'Lowest Price First',
    newestFirst: 'Newest First',
    defaultSort: 'Default',
    salesSort: 'Sales',
    priceSort: 'Price',
    newProductSort: 'Newest',
    arrangement: 'Layout',
    twoColumns: 'Two Columns',
    threeColumns: 'Three Columns',
    singleRow: 'Single Row',
    carouselDisplay: 'Carousel',
    display: 'Show',
    hide: 'Hide',
    componentBackground: 'Component Background',
    productBackground: 'Product Background',
    titleSettings: 'Title Settings',
    titleDisplay: 'Show Title',
    title: 'Title',
    titleColor: 'Title Color',
    titleIcon: 'Title Icon',
    titleIconPlaceholder: 'Enter an icon class',
    productCardSettings: 'Product Style',
    productRadius: 'Product Radius',
    productImageRadius: 'Image Radius',
    productNameColor: 'Product Name Color',
    productTextSize: 'Product Text Size',
    productDescriptionColor: 'Description Color',
    tagSettings: 'Tag Styles',
    ticketTypeTag: 'Ticket Type Tag',
    tagBackground: 'Background',
    tagRadius: 'Radius',
    tagTextColor: 'Text',
    purchaseSettings: 'Purchase and Price',
    buyButton: 'Buy Button',
    buyBackground: 'Buy Background',
    buyRadius: 'Buy Radius',
    buyTextColor: 'Buy Text',
    priceColor: 'Price Color',
    priceSize: 'Price Size',
    salesTextColor: 'Sold Text Color',
    soldCount: '{count} sold',
    stock999Plus: 'Stock 999+',
    noRecommendedProducts: 'No recommended products',
    productSelectionComponent: 'Product Selection',
    defaultProductSelectionTitle: 'Product Selection',
    more: 'More',
    noSelectedProducts: 'No selected products',
    titleIconTextPlaceholder: 'Enter title icon text',
    titleImageDisplay: 'Show Title Image',
    titleImagePath: 'Title Image Original Path',
    enterOriginalImagePath: 'Enter the original image path returned by the server',
    moreDisplay: 'Show More',
    moreTextColor: 'More Text Color',
    backgroundImagePath: 'Background Image Original Path',
    pageSpacing: 'Page Spacing',
    enableCustomStyles: 'Enable Protocol Styles',
    productImageBackground: 'Product Image Background',
    productNameDisplay: 'Show Product Name',
    priceDisplay: 'Show Price',
    priceTagBackground: 'Price Tag Background',
    priceTagImage: 'Price Tag Image',
    priceTagImageSizeHint: 'Recommended: 120px × 36px or the same aspect ratio',
    priceTagRadius: 'Tag Radius',
    priceTopMargin: 'Tag Top Margin',
    productSelectionBackgroundSizeHint: 'Recommended: 750px × 382px or the same aspect ratio',
    cornerRadiusSettings: 'Corner Radius',
    selectLink: 'Select Destination',
    selectLinkPlaceholder: 'Select a destination',
    mallPageDirectory: 'Store Pages',
    decorationPageDirectory: 'Custom Pages',
    noLinkOptions: 'No pages available',
    linkGroupNames: {
      BASIC_PAGE: 'Basic Pages',
      CUSTOM_PAGE: 'Custom Pages',
    },
    basicPageNames: {
      HOME: 'Home',
      PROFILE: 'Profile',
      CATEGORY: 'Categories',
      MEMBER_CODE: 'Member Code',
      PRODUCT_DETAIL: 'Product Details',
      CART: 'Shopping Cart',
    },
  },
};
